import { Link, useParams } from "react-router-dom";
import { ModelTable } from "../components/ModelTable";
import { CompareTray } from "../components/CompareTray";
import {
  useCatalogData,
  useCatalogProvider,
} from "../components/CatalogDataContext";
import { ProviderIcon } from "../components/ProviderIcon";
import { StatusDot } from "../components/ui/StatusDot";
import { MetricBand } from "../components/ui/MetricBand";

export function ProviderDetailPage() {
  const { id } = useParams();
  const provider = useCatalogProvider(id);
  const { models } = useCatalogData();

  if (!provider) {
    return (
      <div className="empty panel">
        <div className="empty-icon">?</div>
        <strong>Provider not found</strong>
        <Link to="/providers">Back to providers</Link>
      </div>
    );
  }
  const list = models.filter((m) => m.providerId === provider.id);
  return (
    <div>
      <p className="eyebrow">01 / PROVIDER</p>
      <div className="detail-header">
        <div>
          <p className="breadcrumb">
            <Link to="/providers">Providers</Link> / {provider.name}
          </p>
          <div className="card-head" style={{ marginBottom: "0.5rem" }}>
            <ProviderIcon provider={provider} size={36} className="card-avatar-img" />
            <div>
              <h1 className="tl-title" style={{ margin: 0, fontSize: "clamp(1.45rem, 2.6vw, 2rem)" }}>
                {provider.name}
              </h1>
              <div className="mt-1 font-mono text-[0.68rem] text-[color:var(--faint)]">
                {provider.id}
              </div>
            </div>
          </div>
          <p className="muted" style={{ margin: "0.35rem 0 0", maxWidth: "60ch" }}>
            {provider.description}
          </p>
          {provider.notes && (
            <p className="muted" style={{ fontStyle: "italic", marginTop: "0.5rem" }}>
              {provider.notes}
            </p>
          )}
        </div>
        <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap", alignItems: "flex-start" }}>
          <StatusDot kind="synced" label={`${list.length} MODELS`} />
          <a className="btn ghost sm" href={provider.website} target="_blank" rel="noreferrer">
            Website
          </a>
          <a className="btn ghost sm" href={provider.docsUrl} target="_blank" rel="noreferrer">
            Docs
          </a>
          <a className="btn sm" href={provider.pricingUrl} target="_blank" rel="noreferrer">
            Pricing →
          </a>
        </div>
      </div>
      <MetricBand
        items={[
          { label: "Models", value: list.length, tone: "amber" },
          { label: "ID", value: provider.id },
          {
            label: "Regions",
            value: provider.regions?.join(", ") ?? "—",
          },
        ]}
      />
      <section className="section panel panel-pad">
        <h2 className="section-title">02 / Details</h2>
        <dl className="kv">
          <dt>ID</dt>
          <dd className="mono">{provider.id}</dd>
          <dt>Models in catalog</dt>
          <dd>{list.length}</dd>
          {provider.regions && (
            <>
              <dt>Regions</dt>
              <dd>{provider.regions.join(", ")}</dd>
            </>
          )}
        </dl>
      </section>
      <section className="section">
        <h2 className="section-title">03 / Models</h2>
        <ModelTable models={list} />
      </section>
      <CompareTray />
    </div>
  );
}
